<script>
import Search from './Search';
import i18n from '@/lib/i18n';
import { Collection, HoldingCollection } from '@/models';
import toNumber from '@/lib/helpers/toNumber';
import toDate from '@/lib/helpers/toDate';

export default {
    name: 'Holding',
    extends: Search,
    props: {
        label: {
            type: String,
            default: i18n.t('holding')
        },
        collection: {
            type: Collection,
            default: () => new HoldingCollection()
        },
        itemKey: {
            type: String,
            default: 'id'
        },
        itemText: {
            type: String,
            default: 'name'
        },
        itemTooltip: {
            type: [String, Function],
            default: () => item => {
                const tooltip = [];

                tooltip.push(`${i18n.t('gi_ref')}: ${item.gi_ref || '-'}`);
                tooltip.push(
                    `${i18n.t('share_quantity')}: ${item.share_quantity ? toNumber(item.share_quantity) : '-'}`
                );
                tooltip.push(`${i18n.t('application_on')}: ${item.application_on ? toDate(item.application_on) : '-'}`);
                tooltip.push(`${i18n.t('share_issue_on')}: ${item.purchased_on ? toDate(item.purchased_on) : '-'}`);

                return tooltip;
            }
        }
    },
    data: () => ({
        createForm: () => import('@/components/forms/CreateHolding')
    })
};
</script>
